import React from 'react';
import { Loader2, X } from 'lucide-react';
import { Badge } from '../../../ui/badge';
import { Button } from '../../../ui/button';
import { Card } from '../../../ui/card';
import { MEMBER_TIER_COLORS, MEMBER_TIER_OPTIONS } from './memberConstants';

const MemberRolesModal = ({
  show,
  selectedMember,
  memberRoles,
  setMemberRoles,
  toggleAdditionalRole,
  savingRoles,
  handleSaveRoles,
  onClose,
}) => {
  if (!show || !selectedMember) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <Card className="w-full max-w-md border-[#2a2a32] bg-[#1e1e24] p-6">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-white">Manage Dad Roles</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="mb-4">
          <p className="text-sm text-gray-400">
            Managing roles for <span className="font-medium text-white">{selectedMember.name}</span>
          </p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="mb-2 block text-sm text-gray-400">Primary Tier</label>
            <select
              value={memberRoles.primary_tier}
              onChange={(event) =>
                setMemberRoles((previous) => ({
                  ...previous,
                  primary_tier: event.target.value,
                  additional_roles: previous.additional_roles.filter(
                    (role) => role !== event.target.value,
                  ),
                }))
              }
              className="w-full rounded-lg border border-[#2a2a32] bg-[#16161a] px-3 py-2 text-white"
            >
              {MEMBER_TIER_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="mb-2 block text-sm text-gray-400">Additional Roles</label>
            <div className="space-y-2">
              {MEMBER_TIER_OPTIONS.filter(
                (option) => option.value !== memberRoles.primary_tier,
              ).map((option) => (
                <label
                  key={option.value}
                  className="flex cursor-pointer items-center gap-3 rounded-lg bg-[#16161a] p-2 hover:bg-[#252530]"
                >
                  <input
                    type="checkbox"
                    checked={memberRoles.additional_roles.includes(option.value)}
                    onChange={() => toggleAdditionalRole(option.value)}
                    className="h-4 w-4 rounded accent-aqua"
                  />
                  <Badge className={MEMBER_TIER_COLORS[option.value]}>{option.label}</Badge>
                </label>
              ))}
            </div>
          </div>

          {(selectedMember.cohorts || []).includes('founding40') ? (
            <div>
              <span className="mr-2 text-sm text-gray-400">Cohort:</span>
              <Badge className="border border-orange-500/25 bg-orange-500/15 text-xs text-orange-300">
                Founding 40
              </Badge>
            </div>
          ) : null}
        </div>

        <div className="mt-6 flex gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 border-[#2a2a32] text-white hover:bg-[#252530]"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveRoles}
            disabled={savingRoles}
            className="flex-1 bg-aqua text-charcoal hover:bg-aqua-dark"
          >
            {savingRoles ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
            Save Roles
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default MemberRolesModal;
